export default class AdminLogsHeadersCreate {
  label() {
    return I18n.t("js.admin.logs.headers.create.create")
  }
}
